import { LocaleMessages } from "vue-i18n";

import { englishMessages } from "./languages/englishMessages";
import { spanishMessages } from "./languages/spanishMessages";
import { Locale } from "./Locale";

/**
 * Messages for Vuei18n localization:
 * https://kazupon.github.io/vue-i18n/guide/messages.html#structure
 */
export const messages: LocaleMessages = {
    [Locale.English]: englishMessages,
    [Locale.Spanish]: spanishMessages
};
